import { render, staticRenderFns } from "./AboutNew.vue?vue&type=template&id=e9788c8c&scoped=true"
import script from "./AboutNew.vue?vue&type=script&lang=js"
export * from "./AboutNew.vue?vue&type=script&lang=js"
import style0 from "./AboutNew.vue?vue&type=style&index=0&id=e9788c8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9788c8c",
  null
  
)

export default component.exports